import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IAddImageRequest, IImage } from '../models/requestModels'

export class PostFirsatApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productImage/firsat-add',
      requesterInfo,
    })
  }

  public async addDoc(request: any): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
